import React, { useState, useRef, useEffect } from "react";
import { Header, Heading, HeadingGroup, Panel, Text, Input, Grid, Row, Col, Button } from "rsuite";
import { useNavigate } from "react-router-dom";
import styles from "./Auth.module.scss";
import { storeToken } from "../../utils/storage";
import { Formik } from "formik";
import { ErrorMessage } from "components";
import { loginValidation } from "validation/AuthValidation";
import AuthAPI from "services/AuthAPI";
import { toast } from "react-toastify";
import { updatePermissions, updateRoleName, updateUserLogin } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { IntroScreen, IntroDisplayTime } from "./IntroScreen";
import { inactiveSessionKey } from "utils/autoLogout";

export default function Login() {
  const navigate = useNavigate();
  const [showIntro, setShowIntro] = useState(false);
  const [isIntroImgLoaded, setIsIntroImgLoaded] = useState(null);
  const isIntroImageLoadCallback = useRef(null)
  const [loginResponse, setLoginResponse] = useState({})

  const dispatch = useDispatch();

  const apiInstance = new AuthAPI();

  useEffect(() => {
    isIntroImageLoadCallback.current = ({isIntroImgLoaded}) => {
      setIsIntroImgLoaded(isIntroImgLoaded)
    }

  }, [isIntroImgLoaded])

  useEffect(() => {
    if(isIntroImgLoaded && loginResponse.statusCode === 200) {
        setShowIntro(true)
        setTimeout(() => {
          dispatch(updateUserLogin(true));
        }, IntroDisplayTime);
      }

  }, [isIntroImgLoaded, loginResponse, dispatch])

  return (
    <>
      <Header className={styles.top__header}>ॐ नमो भगवते वासुदेवाय नमः</Header>
      <div className={styles.container}>
        <div className={styles.login__card}>
          <div className={styles.logo}>
            <img src="/images/logo2.png" alt="" />
          </div>
          <Panel className={styles.panel} shaded>
            <HeadingGroup className="text-center">
              <Heading level={4} className="mb-5">
                Welcome to Kamakshi Money! 👋
              </Heading>
              <Text muted>Please sign-in to your account and start the adventure</Text>
            </HeadingGroup>

            <div>
              <Formik
                initialValues={{
                  name: "",
                  password: "",
                }}
                validationSchema={loginValidation}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(true);
                  setTimeout(async () => {
                    const res = await apiInstance.loginAPI(values);
                    window.localStorage.removeItem(inactiveSessionKey);
                    setLoginResponse(res);
                    if (res && res.statusCode === 200) {
                      if (res.data.token) {
                        storeToken(res.data.token);
                        dispatch(updatePermissions(res.data.permissions));
                        dispatch(updateRoleName(res.data.roleName));
                      } else {
                        navigate("/verify-otp", {
                          state: { userID: res.data.userID },
                        });
                      }

                      toast.success(res.message);
                    } else {
                      toast.error(res.message);
                    }
                    setSubmitting(false);
                  }, 500);
                }}
              >
                {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid fluid>
                      <Row>
                        <Col sm={24}>
                          <div className="form-group">
                            <label className="form-label">Name</label>
                            <Input
                              placeholder="Enter Name"
                              value={values.name || ""}
                              onChange={(value) => {
                                setFieldValue("name", value);
                              }}
                            />
                            <ErrorMessage touched={touched.name} error={errors.name} />
                          </div>
                        </Col>

                        <Col sm={24}>
                          <div className="form-group">
                            <label className="form-label">Password</label>
                            <Input
                              placeholder="Password"
                              value={values.password || ""}
                              onChange={(value) => {
                                setFieldValue("password", value);
                              }}
                              type="password"
                            />
                            <ErrorMessage touched={touched.password} error={errors.password} />
                          </div>
                        </Col>

                        <Col sm={24}>
                          <div className="form-group text-right">
                            <Button appearance="link" size="xs" onClick={() => navigate("/forgot-password")}>
                              Forgot Password?
                            </Button>
                          </div>
                        </Col>

                        <Col sm={24}>
                          <Button block type="submit" appearance="primary" loading={isSubmitting}>
                            Sign in
                          </Button>
                        </Col>
                      </Row>
                    </Grid>
                  </form>
                )}
              </Formik>
            </div>
          </Panel>
        </div>
      </div>
      <IntroScreen 
        showIntro={showIntro}
        updateCallbackRef={isIntroImageLoadCallback}
        />
    </>
  );
}
